import React from 'react';
import {createSelector} from 'reselect';

import Tree from '../tree';
import {removeItemSelection} from '../tree/actions';


export default function(prefix='') {
    return createSelector(
        [() => this.props.store.get('gradesTreeFilter')],
        () => [
            {
                field: prefix + 'grade',
                label: window.gettext('Grade'),
                component: <div style={{fontSize: '.8rem'}}>
                    <Tree
                        store={this.props.store.get('gradesTreeFilter')}
                        readonly
                        header
                        resource='grade'
                        label={window.gettext('Grade')}
                    />
                </div>,
                selected: this.props.store.getIn(['gradesTreeFilter', 'selected']).toJS(),
                remove: id => this.context.store.dispatch(removeItemSelection(
                    id,
                    'grade',
                    this.props.store.getIn(['gradesTreeFilter', 'elementId']),
                )),
            },
        ],
    );
}
